import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navLinks } from '../mock';
import KangoLogo from './KangoLogo';

const Header = ({ onLogin, onCtaBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    // For section anchors, navigate to home if not already there
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const goHome = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button onClick={goHome} className="flex items-center gap-3 group">
          <div className="flex items-center gap-3">
              <KangoLogo className="w-11 h-11 text-amber-400 transition-transform duration-300 group-hover:scale-105" />
              <div className="flex items-center">
                <div className="flex flex-col leading-tight">
                  <span className="text-white font-serif text-[18px] tracking-[0.18em]">KANGO</span>
                  <span className="text-white/70 font-serif text-[11px] tracking-[0.42em]">SCHOOL</span>
                </div>
                <span className="text-amber-400 text-[35px]">9</span>
              </div>
            </div>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((l) => (
            <button
              key={l.name}
              onClick={() => handleNav(l.href)}
              className="text-white/85 hover:text-amber-400 text-[15px] tracking-wide transition-colors duration-200 relative group"
            >
              {l.name}
              <span className="absolute -bottom-1 left-0 right-0 h-px bg-amber-400 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a0a0a] border-t border-white/5 px-6 py-6 space-y-4">
          {navLinks.map((l) => (
            <button
              key={l.name}
              onClick={() => handleNav(l.href)}
              className="block w-full text-left text-white/85 hover:text-amber-400 py-2 text-base"
            >
              {l.name}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
